export default [
	{
		label: 'General',
		value: ''
	},
	{
		label: 'Discovery',
		value: `- Situation\n- Hot buttons\n- Pain points`
	},
	{
		label: 'Alignment',
		value: `- Business owner (yes/not yet)\n- office champion (yes/not yet)`
	},
	{
		label: 'Value',
		value: 'Link to Value Calculator (?)'
	},
	{
		label: 'Set-Up',
		value: `- Login to customers account and check their set up\n- Call customer and book training if not set up`
	},
	{
		label: 'Training',
		value: `- Is there a go live date (yes/not yet)\n- Training plan in place (yes/not yet)`
	}
];


// WEBPACK FOOTER //
// ./app/constants/defaultNoteTypes.js